import React from 'react';

const backButton = ({ onClick }) => {
  return (
    <button className="top-left-back-button" type="button" onClick={onClick}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.828 12L15.778 16.95L14.364 18.364L8.00001 12L14.364 5.63599L15.778 7.04999L10.828 12Z"
          fill="black"
        />
      </svg>
    </button>
  );
};
export default backButton;
